var styles = {
raw: ".hcr-legend-8-6-0{color:var(--hcr-content-secondary-color);display:block;font-family:inherit;font-size:var(--hcr-font-size-primary);font-weight:var(--hcr-font-weight-normal);padding-bottom:var(--hcr-spacing-half);width:100%}",
map:{"hcr-legend":"hcr-legend-8-6-0"}};

export { styles as default };
